import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";

class BusinessUccNimbusRecordHeader extends Component {
  constructor(props) {
    super(props);
    let internId = _.get(props.node, "$.internalID");
    if (!internId)
      internId = _.get(props.node, "[0].$.internalID");
    this.state = {
      internalId: internId,
      formData: props.formData,
    };
  }

  componentWillReceiveProps(nextProps) {
    const internalId = nextProps.node.$.internalID;
    this.setState({
      formData: nextProps.formData,
      internalId,
    });
  }

  onSelectReport = () => {
    this.props.showReport(undefined, "criminalReport", this.state.internalId, {
      internalNameID: 1,
      bttype: this.props.userAccount.btType,
      optReportType: "corp",
    });
  };

  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row className={"result-header"}>
            <Table.Cell className={"icon-align-middle"}>
              {this.props.companyName}
            </Table.Cell>
            {this.props.showReportButton &&
              <Table.Cell className="float-right-nomobile">
                <Button primary onClick={() => this.onSelectReport()}>
                  Report
                </Button>
              </Table.Cell>}
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default BusinessUccNimbusRecordHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessUccNimbusRecordHeader.js